<!--
 * @Author: your name
 * @Date: 2021-05-27 18:50:29
 * @LastEditTime: 2021-05-29 11:09:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \txm-manager-fe\src\components\menu\MessageJump\MessageJump.vue
-->
<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <el-button @click="addMessage" type="primary" :loading="resetLoading">
        创建短链
      </el-button>
    </base-header>
    <el-main>
      <el-table
        :data="message_list"
        stripe
        style="width: 100%"
        v-loading="tableLoading"
        height="100%"
      >
        <el-table-column align="center" label="标题">
          <template slot-scope="scope">{{
            scope.row.title
          }}</template>
        </el-table-column>
        <el-table-column fixed prop="jump_url" align="center" label="短链url">
          <template slot-scope="scope">
            <span>{{ scope.row.jump_url }}</span>
            <p @click="copyUrl(scope.row.jump_url)">复制</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="关联微信群">
          <template slot-scope="scope">{{
            scope.row.chatroomname_list | getLength
          }}</template>
        </el-table-column>

        <el-table-column label="数据" align="center">
          <template v-slot="scope">
            <p @click="exportData(scope.row.jump_id)">导出数据</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template v-slot="scope">
            <el-button type="primary" @click="editMessage(scope.row)"
              >编辑</el-button
            >
            <el-button type="primary" @click="delMessage(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </el-footer>
    <!-- 编辑短信链接弹框 -->
    <el-dialog title="编辑短链" :visible.sync="dialogFormVisible" width="50%">
      <el-form :model="form" label-position="left">
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-input
            style="width: 220px"
            v-model="form.title"
            autocomplete="off"
            maxlength="20"
            placeholder="输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="团长" :label-width="formLabelWidth">
          <el-input
            style="width: 220px"
            v-model="form.client_id"
            autocomplete="off"
            placeholder="输入团长ID"
          ></el-input>
          <el-button type="primary" @click="getGroupById">确定</el-button>
        </el-form-item>
        <el-form-item label="群ID" :label-width="formLabelWidth">
          <el-select
            v-model="value1"
            placeholder="选择关联群"
            style="width: 220px"
            multiple="true"
          >
            <el-option
              v-for="item in chatroom_list"
              :key="item.chatroomname"
              :label="item.nickname"
              :value="item.chatroomname"
              >{{ item.nickname }}({{ item.member_count }}人)</el-option
            >
          </el-select>
        </el-form-item>

        <!-- 上传背景图 -->
        <el-form-item label="上传背景图  ">
          <el-upload
            :action="uploadUrl"
            :data="{ token: this.token }"
            ref="goodPicture"
            list-type="picture-card"
            :before-upload="beforeUpload"
            :file-list="goods_pic_list"
            limit="1"
            multiple
            :on-remove="
              (file, fileList) => remove(file, fileList, 'goods_pic_list')
            "
            :on-success="
              (response, file, fileList) =>
                onsuccess(response, file, fileList, 'goods_pic_list')
            "
          >
            <i class="el-icon-plus" style="line-height: 148px"></i>
          </el-upload>
        </el-form-item>
        <!-- 上传接口中间页 -->
        <el-form-item label="上传中间页跳转背景">
          <el-upload
            :action="uploadUrl"
            :data="{ token: this.token }"
            ref="personPicture"
            list-type="picture-card"
            :file-list="person_pic_list"
            limit="1"
            multiple
            :on-remove="
              (file, fileList) => remove(file, fileList, 'person_pic_list')
            "
            :on-success="
              (response, file, fileList) =>
                onsuccess(response, file, fileList, 'person_pic_list')
            "
          >
            <i class="el-icon-plus" style="line-height: 148px"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="上传个人二维码">
          <el-upload
            :action="uploadUrl"
            :data="{ token: this.token }"
            :on-preview="handlePreview"
            :on-remove="
              (file, fileList) => remove(file, fileList, 'file_PersonList')
            "
            :before-remove="beforeRemove"
            multiple
            :on-exceed="handleExceed"
            :file-list="file_PersonList"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <!-- 只能上传jpg/png文件 -->
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import pageMixin from "../../../mixins/page";
import getTokenMixin from "../../../mixins/getToken";
export default {
  name: "MessageJump",
  mixins: [pageMixin, getTokenMixin],
  data() {
    return {
      GetClientChartroomURL:
        this.getDomain() + "bmMiniJump/get_client_chatroom",
      createJumpURL: this.getDomain() + "bmMiniJump/create_jump_url",
      JumpListURL: this.getDomain() + "bmMiniJump/get_jump_list",
      DeleteJumpInfoURL: this.getDomain() + "bmMiniJump/delete_jump_info",
      updateCompanyURL: this.getDomain() + "bmcompany/update_company",
      uploadUrl: this.getDomain() + "bmuser/upload_oss", // 图片上传,
      token: sessionStorage.token,
      dialogFormVisible: false,
      formLabelWidth: "100px",
      form: {
        client_id: null,
        edit: false,
      },
      labelPosition: "left",
      message_list: [],
      chatroom_list: [],
      isAddMessage: false,
      editBalance: "",
      value1: [],
      goods_pic_list: [],
      person_pic_list: [],
      jump_id: "",
      file_PersonList: [],
    };
  },
  filters: {
    getLength(msg) {
      return msg.length;
    },
  },
  created() {
    // this.getMansionInfo();
    this.getList();
  },
  methods: {
    // 上传多张二维码图片处理
    handleSuccess(response, file, fileList) {
      if (response.err_code == 0) {
        this.file_PersonList.push({
          name: file.name,
          url: response.content.oss_url,
        });
      }

      // this.fileList.push({
      //     name: fileList[0].name,
      //     url: fileList[0].response.content.oss_url,
      //   });
      //   console.log(fileList[0]);
    },

    // 导出数据
    exportData(id) {
      window.open(
        `${this.getDomain()}bmMiniJump/export_data?jump_id=${id}&token=${
          this.token
        }`
      );
    },

    // 点击复制的方法
    copyUrl(url) {
      // 创建一个 Input标签
      const cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      this.$message({
        type: "success",
        message: "复制成功",
      });
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },

    getGroupById() {
      this.value1 = [];
      let params = { client_id: String(this.form.client_id) };
      let handle = (res) => {
        this.chatroom_list = res.data.content.chatroom_list;
      };
      this.__axios(this.GetClientChartroomURL, params, handle);
    },

    // 上传图片前检测
    beforeUpload(file) {
      console.log(file);
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (file.type === "video/mp4") {
        this.$message.error("请上传正确图片格式");
        return false;
      }
      if (!isLt4M) {
        this.$message.error("上传图片大小不能超过4MB");
        return false;
      }
      if (/[ \u4e00-\u9fa5]/.test(file.name)) {
        this.$message.error("文件名不能为中文");
        return false;
      }

      return isLt4M;
    },
    remove(file, fileList, val) {
      this[val] = fileList;
    },
    onsuccess(response, file, fileList, val) {
      if (response.err_code !== 0) {
        this.$alert("图片上传失败", "错误", {
          confirmButtonText: "确定",
        });
      } else {
        this[val].push({
          name: fileList[0].name,
          url: fileList[0].response.content.oss_url,
        });

        console.log(fileList[0]);
      }
    },
    // 添加短信链接
    addMessage() {
      this.dialogFormVisible = true;
      this.isAddMessage = true;
      this.form = {
        client_id: null,
        edit: false,
      };
      this.goods_pic_list = [];
      this.person_pic_list = [];
      this.file_PersonList = [];
      this.chatroom_list = [];
      this.value1 = [];
      this.jump_id = "";
    },
    // 提交
    submit() {
      if (!this.form.title) {
        this.$message.error('请输入标题');
        return
      }
      let url = this.createJumpURL;
      let handle = (res) => {
        console.log(res);
        this.dialogFormVisible = false;
        this.form = {
          client_id: null,
          edit: false,
        };
        this.goods_pic_list = [];
        this.person_pic_list = [];
        this.chatroom_list = [];
        this.file_PersonList = [];
        this.value1 = [];
        this.getList();
      };
      // 非空判断
      if (this.isAddMessage == true) {
        let params = {
          client_id: String(this.form.client_id),
          title: String(this.form.title),
          bg_url: this.goods_pic_list[0].url,
          h5_pic_url: this.person_pic_list[0]
            ? this.person_pic_list[0].url
            : null,
          chatroomname_list: this.value1,
          person_qrcode_list: this.file_PersonList.map((item) => {
            return item.url;
          }),
        };
        this.__axios(url, params, handle);
      } else {
        let params = {
          jump_id: this.jump_id,
          client_id: String(this.form.client_id),
          title: String(this.form.title),
          bg_url: this.goods_pic_list[0].url,
          h5_pic_url: this.person_pic_list[0]
            ? this.person_pic_list[0].url
            : null,
          chatroomname_list: this.value1,
          person_qrcode_list: this.file_PersonList.map((item) => {
            return item.url;
          }),
        };
        this.__axios(url, params, handle);
      }
    },
    getList() {
      this.tableLoading = true;
      let params = {
        page: this.page,
        pagesize: this.pagesize,
      };
      let handle = (res) => {
        this.totalCount = res.data.content.total;
        this.message_list = res.data.content.jump_list;
        this.tableLoading = false;
      };
      this.__axios(this.JumpListURL, params, handle);
    },
    // 编辑短链
    editMessage(row) {
      this.isAddMessage = false;
      this.dialogFormVisible = true;
      this.form = {
        client_id: row.client_id,
        edit: true,
        title: row.title
      };
      this.getGroupById();
      this.goods_pic_list = [];
     
      if (row.bg_url) {
        let arr = row.bg_url.split("/");
        this.goods_pic_list[0] = {
          name: arr.pop(),
          url: row.bg_url,
        };
      }
      if (row.h5_pic_url!=null) {
        this.person_pic_list[0] = {
          name: row.h5_pic_url.split("/").pop(),
          url: row.h5_pic_url,
        };
      }else{
         this.person_pic_list = [];
      }

      this.file_PersonList = row.person_qrcode_list.map((item) => {
        return {
          name: item.split("/").pop(),
          url: item,
        };
      });

      this.value1 = row.chatroomname_list;
      this.jump_id = row.jump_id;
    },
    // 删除短链
    delMessage(row) {
      const params = {
        jump_id: row.jump_id,
      };
      let handle = (res) => {
        if (res.data.err_code == 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getList();
        }
      };
      this.__axios(this.DeleteJumpInfoURL, params, handle);
    },
  },
};
</script>

<style scoped>
p {
  cursor: pointer;
  color: #3a8ee6;
}
.bg {
  border: 1px dotted #d9d9d9;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
